/* eslint-disable */
import React, { useState } from "react"

export default function PartProductBox({
  productItem,
  onPartProductBoxSelect,
  index,
  ...props
}) {
  const [selected, setSelected] = useState(false)
  const toggleSelected = () => setSelected(value => !value)

  const handleClick = (index, event) => {
    onPartProductBoxSelect(index, event)
    toggleSelected()
  }

  const partPrice = +parseFloat(
    productItem.priceRangeV2.minVariantPrice.amount,
  ).toFixed(2)

  let stockStatus
  let preorderDate
  const quantity = productItem.variants[0].inventoryQuantity
  const available = productItem.variants[0].availableForSale
  const inventoryPolicy = productItem.variants[0].inventoryPolicy === "CONTINUE"

  const preorderMetafieldArr = productItem.variants[0].metafields.filter(
    metafield => metafield.key === "preorder-date",
  )

  if (preorderMetafieldArr.length > 0) {
    preorderDate = preorderMetafieldArr[0].value
  }

  if (quantity > 0) {
    stockStatus = "In Stock"
  } else if (available && inventoryPolicy) {
    stockStatus = "Preorder"
  } else {
    stockStatus = "Out Of Stock"
  }

  return (
    <div>
      <button
        type="button"
        className={`border-2 border-solid mb-3 flex lg:block items-center justify-between productBox rounded lg:pt-4 pt-2 pb-2 lg:pb-4 pl-2 pr-2 w-full ${
          selected ? "selected" : ""
        } ${stockStatus === "Out Of Stock" ? "out-of-stock" : ""}`}
        value={productItem.variants[0].storefrontId}
        onClick={event => handleClick(index, event)}
      >
        {productItem.metafields
          .filter(metafield => metafield.key === "component-name")
          .map(metafield => (
            <p className="font-extrabold font-condensed text-sm lg:text-xl mb-0.5">
              {metafield.value}
            </p>
          ))}
        <p className="font-bold font-condensed text-sm lg:text-lg mb-0">
          {stockStatus === "Out Of Stock" ? "Out Of Stock" : `$${partPrice}`}
        </p>
        {/*<p>Stock Status: {stockStatus}</p>*/}
        {/*preorderDate ? <p>Preorder Date: {preorderDate}</p> : ''*/}
      </button>
    </div>
  )
}
